import { QuoteCardAuthor, QuoteCardBadges, QuoteCardImage } from './parts';
import type { QuoteItem } from './type';

export function QuoteCarouselItem({ quote, attribution, image, badges, link }: QuoteItem) {
  return (
    <div className="flex flex-col @lg:flex-row @lg:items-center gap-6 @lg:gap-16">
      <QuoteCardImage image={image} alt={attribution} />
      <div className="flex flex-col gap-4 min-w-0 flex-1 @lg:pb-16">
        <blockquote
          className="font-serif font-normal text-[32px] @lg:text-[44px] leading-[1.2] @lg:leading-[1.1] tracking-[-0.64px] @lg:tracking-[-0.88px] text-brand-text-button"
          dangerouslySetInnerHTML={{ __html: quote }}
        ></blockquote>
        <QuoteCardAuthor attribution={attribution} link={link} />
        <QuoteCardBadges badges={badges} />
      </div>
    </div>
  );
}
